import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const buyers = [{
  name: 'María G.',
  location: 'Buenos Aires, Argentina',
  time: 'hace 2 min'
}, {
  name: 'Laura P.',
  location: 'Ciudad de México, México',
  time: 'hace 5 min'
}, {
  name: 'Ana S.',
  location: 'Madrid, España',
  time: 'hace 8 min'
}, {
  name: 'Camila R.',
  location: 'Bogotá, Colombia',
  time: 'hace 12 min'
}, {
  name: 'Valentina M.',
  location: 'Santiago, Chile',
  time: 'hace 15 min'
}, {
  name: 'Isabella T.',
  location: 'Lima, Perú',
  time: 'hace 18 min'
}, {
  name: 'Fernanda L.',
  location: 'Montevideo, Uruguay',
  time: 'hace 22 min'
}, {
  name: 'Daniela C.',
  location: 'San José, Costa Rica',
  time: 'hace 25 min'
}, {
  name: 'Lucía H.',
  location: 'Barcelona, España',
  time: 'hace 30 min'
}, {
  name: 'Gabriela V.',
  location: 'Quito, Ecuador',
  time: 'hace 35 min'
}, {
  name: 'Sofía K.',
  location: 'Miami, Estados Unidos',
  time: 'hace 40 min'
}, {
  name: 'Martina D.',
  location: 'Asunción, Paraguay',
  time: 'hace 45 min'
}, {
  name: 'Paula B.',
  location: 'Medellín, Colombia',
  time: 'hace 50 min'
}, {
  name: 'Carla N.',
  location: 'Guadalajara, México',
  time: 'hace 1 hora'
}, {
  name: 'Andrea F.',
  location: 'São Paulo, Brasil',
  time: 'hace 1 hora'
}];
export function PurchasePopup() {
  const [currentBuyer, setCurrentBuyer] = useState<(typeof buyers)[0] | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    let buyerIndex = 0;
    const initialTimeout = setTimeout(() => {
      if (!dismissed) {
        setCurrentBuyer(buyers[buyerIndex]);
        setIsVisible(true);
        setTimeout(() => setIsVisible(false), 4500);
        buyerIndex++;
      }
    }, 10000);
    const interval = setInterval(() => {
      if (!dismissed && buyerIndex < buyers.length) {
        setCurrentBuyer(buyers[buyerIndex]);
        setIsVisible(true);
        setTimeout(() => setIsVisible(false), 4500);
        buyerIndex = (buyerIndex + 1) % buyers.length;
      }
    }, 30000 + Math.random() * 20000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, [dismissed]);
  if (dismissed) return null;
  return <AnimatePresence data-id="element-358">
      {isVisible && currentBuyer && <motion.div initial={{
      x: -320,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -320,
      opacity: 0
    }} transition={{
      type: 'spring',
      damping: 25,
      stiffness: 300
    }} className="fixed bottom-[85px] md:bottom-6 left-4 z-50 max-w-[300px] md:max-w-[340px]" data-id="element-359">
          <div className="bg-linen/95 backdrop-blur-sm rounded-lg border border-copper/15 px-4 py-2.5 flex items-center gap-3 cursor-pointer" onClick={() => {
        setIsVisible(false);
        setDismissed(true);
      }} data-id="element-360">
            <span className="text-base flex-shrink-0" data-id="element-361">🧶</span>
            <p className="text-xs text-deep-brown leading-snug" data-id="element-362">
              <span className="font-bold" data-id="element-363">{currentBuyer.name}</span> de{' '}
              {currentBuyer.location} obtuvo la colección de patrones por raza ·{' '}
              <span className="text-gray-400" data-id="element-364">{currentBuyer.time}</span>
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}